import {
  ComponentParams,
  ComponentRendering,
  Field,
  LinkField,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { C43MediaGalleryItemFields } from '../C43MediaGalleryItem/C43MediaGalleryItem.types';
import {
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';

export type C43MediaGalleryProps = {
  rendering?: ComponentRendering & {
    params?: ComponentParams;
    placeholders?: C43MediaGalleryPlaceholder;
  };
  params?: ComponentParams & C43MediaGalleryParams;
  fields?: C43MediaGalleryFields;
};

export type C43MediaGalleryFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
};

export type C43MediaGalleryParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
  BackgroundColor?: string;
  HideThumbnails?: string;
  HideNavigation?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C43MediaGalleryPlaceholder = {
  'media-gallery-container-{*}'?: {
    componentName?: string;
    fields?: C43MediaGalleryItemFields;
  }[];
};
